export const KEYS = {
  PNL_SUMMARY: (account: string) => `/accounts/${account}/pnl_summary`,
  PNL_HISTORY: (account: string) => `/accounts/${account}/pnl_history`,
  TRADES: (account: string) => `/accounts/${account}/trades`,
  ORDERS: (account: string) => `/accounts/${account}/orders`,
  POSITIONS: (account: string) => `/accounts/${account}/positions`,
};
